// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-production-mix-chart {
  position: relative;
  width: 100%;
  min-height: 365px;
  overflow: hidden;
}
.operator-production-mix-chart--visible {
  animation: operatorMixContainerEnter 0.65s ease-out both;
}
.operator-production-mix-chart--loading {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 365px;
}
.operator-production-mix-chart__chart {
  animation: operatorMixChartEnter 0.8s ease-out both;
  transform-origin: center;
}
.operator-production-mix-chart__empty {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: #94a3b8;
  font-size: 12px;
  animation: operatorMixEmptyEnter 0.45s ease-out both;
}
.operator-production-mix-chart__empty-icon {
  font-size: 34px;
  line-height: 1;
  opacity: 0.55;
  animation: operatorMixEmptyFloat 2s ease-in-out infinite;
}
.operator-production-mix-chart__quality {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 18px 12px;
  padding: 13px 16px;
  border: 1px solid #e8edf5;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
  animation: operatorMixQualityEnter 0.55s 0.35s ease-out both;
}
.operator-production-mix-chart__quality span {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}
.operator-production-mix-chart__quality strong {
  color: #10b981;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.3px;
}
.operator-production-mix-chart__quality--loading {
  animation: none;
}
.operator-production-mix-chart .apexcharts-pie-area {
  cursor: pointer;
  transition: filter 0.25s ease, opacity 0.25s ease;
}
.operator-production-mix-chart .apexcharts-datalabel-label,
.operator-production-mix-chart .apexcharts-datalabel-value {
  animation: operatorMixCenterLabelEnter 0.45s 0.6s ease-out both;
}
.operator-production-mix-chart .apexcharts-legend-series {
  opacity: 0;
  animation: operatorMixLegendEnter 0.4s ease-out forwards;
}
.operator-production-mix-chart .apexcharts-legend-series:nth-child(1) {
  animation-delay: 0.65s;
}
.operator-production-mix-chart .apexcharts-legend-series:nth-child(2) {
  animation-delay: 0.78s;
}
.operator-production-mix-chart .apexcharts-legend-series:nth-child(3) {
  animation-delay: 0.91s;
}

.operator-production-mix-chart__skeleton {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.operator-mix-skeleton-donut {
  position: relative;
  width: 205px;
  height: 205px;
  border-radius: 50%;
  background: conic-gradient(#dce4ef 0deg 95deg, #edf1f6 95deg 175deg, #d5deea 175deg 275deg, #e8edf4 275deg 360deg);
  animation: operatorMixSkeletonRotate 2.4s linear infinite, operatorMixSkeletonPulse 1.4s ease-in-out infinite;
}
.operator-mix-skeleton-donut::after {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  content: "";
  background: linear-gradient(115deg, transparent 20%, rgba(255, 255, 255, 0.72) 48%, transparent 76%);
  animation: operatorMixSkeletonShimmer 1.5s linear infinite;
}

.operator-mix-skeleton-center {
  position: absolute;
  z-index: 2;
  inset: 39px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px #eef2f7;
}

.operator-mix-skeleton-legend {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  margin-top: 27px;
}

.operator-mix-skeleton-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  opacity: 0;
  animation: operatorMixLegendEnter 0.4s ease-out forwards;
}
.operator-mix-skeleton-legend-item span {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #d8e0ec;
}
.operator-mix-skeleton-legend-item i {
  display: block;
  width: 44px;
  height: 9px;
  border-radius: 6px;
  background: #e7ecf3;
}

.operator-mix-quality-skeleton {
  width: 95px;
  height: 11px;
  border-radius: 8px;
  background: #e4eaf2;
  animation: operatorMixSkeletonPulse 1.3s ease-in-out infinite;
}

.operator-mix-value-skeleton {
  width: 58px;
  height: 18px;
  border-radius: 8px;
  background: #dce4ee;
  animation: operatorMixSkeletonPulse 1.3s 0.15s ease-in-out infinite;
}

@keyframes operatorMixContainerEnter {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes operatorMixChartEnter {
  from {
    opacity: 0;
    transform: scale(0.82) rotate(-8deg);
    filter: blur(2px);
  }
  to {
    opacity: 1;
    transform: scale(1) rotate(0);
    filter: blur(0);
  }
}
@keyframes operatorMixCenterLabelEnter {
  from {
    opacity: 0;
    transform: translateY(7px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes operatorMixLegendEnter {
  from {
    opacity: 0;
    transform: translateY(7px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes operatorMixQualityEnter {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes operatorMixEmptyEnter {
  from {
    opacity: 0;
    transform: scale(0.94);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes operatorMixEmptyFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
@keyframes operatorMixSkeletonRotate {
  to {
    transform: rotate(360deg);
  }
}
@keyframes operatorMixSkeletonPulse {
  0%, 100% {
    opacity: 0.58;
  }
  50% {
    opacity: 1;
  }
}
@keyframes operatorMixSkeletonShimmer {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .operator-production-mix-chart--visible,
  .operator-production-mix-chart__chart,
  .operator-production-mix-chart__quality,
  .operator-production-mix-chart__empty,
  .operator-production-mix-chart__empty-icon,
  .operator-mix-skeleton-donut,
  .operator-mix-skeleton-legend-item,
  .operator-mix-quality-skeleton,
  .operator-mix-value-skeleton,
  .apexcharts-datalabel-label,
  .apexcharts-datalabel-value,
  .apexcharts-legend-series {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/Dashboard/operator-utilization/components/OperatorProductionMixChart.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AACF;AACE;EACE,wDAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AAAJ;AAGE;EACE,mDAAA;EACA,wBAAA;AADJ;AAIE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,oDAAA;AAFJ;AAKE;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,wDAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6DAAA;EAKA,6CAAA;EACA,4DAAA;AARJ;AAUI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AARN;AAWI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AATN;AAYI;EACE,eAAA;AAVN;AAcE;EACE,eAAA;EACA,iDACE;AAbN;AAiBE;;EAEE,+DAAA;AAfJ;AAkBE;EACE,UAAA;EACA,wDAAA;AAhBJ;AAkBI;EACE,sBAAA;AAhBN;AAmBI;EACE,sBAAA;AAjBN;AAoBI;EACE,sBAAA;AAlBN;;AAuBA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kHAAA;EAMA,6GACE;AA1BJ;AA6BE;EACE,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,WAAA;EACA,oGAAA;EAMA,0DAAA;AAhCJ;;AAoCA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,mCAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,wDAAA;AAjCF;AAmCE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAjCJ;AAoCE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAlCJ;;AAsCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6DAAA;AAnCF;;AAsCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mEAAA;AAnCF;;AAsCA;EACE;IACE,UAAA;IACA,2BAAA;EAnCF;EAsCA;IACE,UAAA;IACA,wBAAA;EApCF;AACF;AAuCA;EACE;IACE,UAAA;IACA,oCAAA;IACA,iBAAA;EArCF;EAwCA;IACE,UAAA;IACA,6BAAA;IACA,eAAA;EAtCF;AACF;AAyCA;EACE;IACE,UAAA;IACA,0BAAA;EAvCF;EA0CA;IACE,UAAA;IACA,wBAAA;EAxCF;AACF;AA2CA;EACE;IACE,UAAA;IACA,0BAAA;EAzCF;EA4CA;IACE,UAAA;IACA,wBAAA;EA1CF;AACF;AA6CA;EACE;IACE,UAAA;IACA,uCAAA;EA3CF;EA8CA;IACE,UAAA;IACA,iCAAA;EA5CF;AACF;AA+CA;EACE;IACE,UAAA;IACA,sBAAA;EA7CF;EAgDA;IACE,UAAA;IACA,mBAAA;EA9CF;AACF;AAiDA;EACE;IAEE,wBAAA;EAhDF;EAmDA;IACE,2BAAA;EAjDF;AACF;AAoDA;EACE;IACE,yBAAA;EAlDF;AACF;AAqDA;EACE;IAEE,aAAA;EApDF;EAuDA;IACE,UAAA;EArDF;AACF;AAwDA;EACE;IACE,uBAAA;EAtDF;EAyDA;IACE,yBAAA;EAvDF;AACF;AA0DA;EACE;;;;;;;;;;;;IAYE,eAAA;EAxDF;AACF","sourcesContent":[".operator-production-mix-chart {\n  position: relative;\n  width: 100%;\n  min-height: 365px;\n  overflow: hidden;\n\n  &--visible {\n    animation: operatorMixContainerEnter 0.65s ease-out both;\n  }\n\n  &--loading {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-height: 365px;\n  }\n\n  &__chart {\n    animation: operatorMixChartEnter 0.8s ease-out both;\n    transform-origin: center;\n  }\n\n  &__empty {\n    min-height: 300px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 9px;\n    color: #94a3b8;\n    font-size: 12px;\n    animation: operatorMixEmptyEnter 0.45s ease-out both;\n  }\n\n  &__empty-icon {\n    font-size: 34px;\n    line-height: 1;\n    opacity: 0.55;\n    animation: operatorMixEmptyFloat 2s ease-in-out infinite;\n  }\n\n  &__quality {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 4px 18px 12px;\n    padding: 13px 16px;\n    border: 1px solid #e8edf5;\n    border-radius: 12px;\n    background: linear-gradient(\n      135deg,\n      #f8fafc 0%,\n      #ffffff 100%\n    );\n    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);\n    animation: operatorMixQualityEnter 0.55s 0.35s ease-out both;\n\n    span {\n      color: #64748b;\n      font-size: 12px;\n      font-weight: 600;\n    }\n\n    strong {\n      color: #10b981;\n      font-size: 18px;\n      font-weight: 800;\n      letter-spacing: -0.3px;\n    }\n\n    &--loading {\n      animation: none;\n    }\n  }\n\n  .apexcharts-pie-area {\n    cursor: pointer;\n    transition:\n      filter 0.25s ease,\n      opacity 0.25s ease;\n  }\n\n  .apexcharts-datalabel-label,\n  .apexcharts-datalabel-value {\n    animation: operatorMixCenterLabelEnter 0.45s 0.6s ease-out both;\n  }\n\n  .apexcharts-legend-series {\n    opacity: 0;\n    animation: operatorMixLegendEnter 0.4s ease-out forwards;\n\n    &:nth-child(1) {\n      animation-delay: 0.65s;\n    }\n\n    &:nth-child(2) {\n      animation-delay: 0.78s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: 0.91s;\n    }\n  }\n}\n\n.operator-production-mix-chart__skeleton {\n  min-height: 300px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.operator-mix-skeleton-donut {\n  position: relative;\n  width: 205px;\n  height: 205px;\n  border-radius: 50%;\n  background: conic-gradient(\n    #dce4ef 0deg 95deg,\n    #edf1f6 95deg 175deg,\n    #d5deea 175deg 275deg,\n    #e8edf4 275deg 360deg\n  );\n  animation:\n    operatorMixSkeletonRotate 2.4s linear infinite,\n    operatorMixSkeletonPulse 1.4s ease-in-out infinite;\n\n  &::after {\n    position: absolute;\n    inset: 0;\n    border-radius: inherit;\n    content: \"\";\n    background: linear-gradient(\n      115deg,\n      transparent 20%,\n      rgba(255, 255, 255, 0.72) 48%,\n      transparent 76%\n    );\n    animation: operatorMixSkeletonShimmer 1.5s linear infinite;\n  }\n}\n\n.operator-mix-skeleton-center {\n  position: absolute;\n  z-index: 2;\n  inset: 39px;\n  border-radius: 50%;\n  background: #ffffff;\n  box-shadow: inset 0 0 0 1px #eef2f7;\n}\n\n.operator-mix-skeleton-legend {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  margin-top: 27px;\n}\n\n.operator-mix-skeleton-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  opacity: 0;\n  animation: operatorMixLegendEnter 0.4s ease-out forwards;\n\n  span {\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    background: #d8e0ec;\n  }\n\n  i {\n    display: block;\n    width: 44px;\n    height: 9px;\n    border-radius: 6px;\n    background: #e7ecf3;\n  }\n}\n\n.operator-mix-quality-skeleton {\n  width: 95px;\n  height: 11px;\n  border-radius: 8px;\n  background: #e4eaf2;\n  animation: operatorMixSkeletonPulse 1.3s ease-in-out infinite;\n}\n\n.operator-mix-value-skeleton {\n  width: 58px;\n  height: 18px;\n  border-radius: 8px;\n  background: #dce4ee;\n  animation: operatorMixSkeletonPulse 1.3s 0.15s ease-in-out infinite;\n}\n\n@keyframes operatorMixContainerEnter {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes operatorMixChartEnter {\n  from {\n    opacity: 0;\n    transform: scale(0.82) rotate(-8deg);\n    filter: blur(2px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) rotate(0);\n    filter: blur(0);\n  }\n}\n\n@keyframes operatorMixCenterLabelEnter {\n  from {\n    opacity: 0;\n    transform: translateY(7px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes operatorMixLegendEnter {\n  from {\n    opacity: 0;\n    transform: translateY(7px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes operatorMixQualityEnter {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.97);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes operatorMixEmptyEnter {\n  from {\n    opacity: 0;\n    transform: scale(0.94);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes operatorMixEmptyFloat {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-5px);\n  }\n}\n\n@keyframes operatorMixSkeletonRotate {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes operatorMixSkeletonPulse {\n  0%,\n  100% {\n    opacity: 0.58;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes operatorMixSkeletonShimmer {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .operator-production-mix-chart--visible,\n  .operator-production-mix-chart__chart,\n  .operator-production-mix-chart__quality,\n  .operator-production-mix-chart__empty,\n  .operator-production-mix-chart__empty-icon,\n  .operator-mix-skeleton-donut,\n  .operator-mix-skeleton-legend-item,\n  .operator-mix-quality-skeleton,\n  .operator-mix-value-skeleton,\n  .apexcharts-datalabel-label,\n  .apexcharts-datalabel-value,\n  .apexcharts-legend-series {\n    animation: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
